export enum TimeLeftEnum {
  Days,
  Hours,
  Minutes,
  Seconds,
  TotalSeconds
}
